export default (href) => {
    const link = href.startsWith('www.') ? `//${href}` : href;
    const url = link.startsWith('//') ? `http:${link}` : link;
    const urlHostname = url.startsWith('http') ? new URL(url).hostname : url;

    const isUrl = url.startsWith('http');
    const isClearScore = new RegExp('clearscore').test(urlHostname) || new RegExp('cs55').test(urlHostname);
    const isExternalDomain = isUrl && !isClearScore;

    const isInternalLink =
        !isExternalDomain && !url.startsWith('mailto:') && !url.startsWith('tel:') && !url.startsWith('sms:');

    return isInternalLink;
};
